export default __webpack_public_path__ + "static/media/graceKeynoteHeadingHero_particles.7e94a279.png";